import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import './Clients.css';

const STORAGE_KEY = 'ryzenos_clients';
const fmtINR = v => v>=100000?'₹'+(v/100000).toFixed(1)+'L':v>=1000?'₹'+(v/1000).toFixed(0)+'K':v?'₹'+v:'—';
const fmtDate = d => d?new Date(d).toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric'}):'—';
const initials = n => n?n.split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase():'?';
const genId = () => Date.now()+Math.random();

const STATUS_OPTIONS = ['Active','Completed','On Hold','Churned'];
const PAY_OPTIONS = ['','Unpaid','Partially Paid','Paid','Overdue','Cancelled'];
const SOURCES = ['Leads Conversion','Meta Ads','BNI Referral','Referral','Direct','Website','Other'];

const CloseIcon = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const SearchIcon = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>;
const PlusIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const EditIcon = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;

function ClientModal({ client, theme, onClose, onSave }) {
  const blank = {name:'',company:'',businessType:'',phone:'',email:'',location:'',source:'Direct',service:'',value:'',payStatus:'',clientStatus:'Active',notes:'',convertedAt:new Date().toISOString()};
  const [form, setForm] = useState(client ? {...client} : blank);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const submit = () => {
    if (!form.name.trim()) return;
    onSave({...form, id:client?client.id:genId(), value:parseInt(form.value)||0});
    onClose();
  };
  return (
    <div className="cl-overlay" onClick={onClose}>
      <div className="cl-modal" data-theme={theme} onClick={e=>e.stopPropagation()}>
        <div className="cl-modal-hd"><span className="cl-modal-title">{client?'Edit Client':'Add Client'}</span><button className="cl-icon-btn" onClick={onClose}><CloseIcon/></button></div>
        <div className="cl-modal-body">
          <div className="cl-form-row">
            <div className="cl-form-grp"><label className="cl-lbl">Name *</label><input className="cl-inp" placeholder="Full name" value={form.name} onChange={e=>set('name',e.target.value)}/></div>
            <div className="cl-form-grp"><label className="cl-lbl">Company</label><input className="cl-inp" placeholder="Company name" value={form.company} onChange={e=>set('company',e.target.value)}/></div>
          </div>
          <div className="cl-form-row">
            <div className="cl-form-grp"><label className="cl-lbl">Phone</label><input className="cl-inp" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={e=>set('phone',e.target.value)}/></div>
            <div className="cl-form-grp"><label className="cl-lbl">Email</label><input className="cl-inp" placeholder="email@company.com" value={form.email} onChange={e=>set('email',e.target.value)}/></div>
          </div>
          <div className="cl-form-row">
            <div className="cl-form-grp"><label className="cl-lbl">Business Type</label><input className="cl-inp" placeholder="e.g. Restaurant, IT" value={form.businessType} onChange={e=>set('businessType',e.target.value)}/></div>
            <div className="cl-form-grp"><label className="cl-lbl">Location</label><input className="cl-inp" placeholder="City, State" value={form.location} onChange={e=>set('location',e.target.value)}/></div>
          </div>
          <div className="cl-form-row">
            <div className="cl-form-grp"><label className="cl-lbl">Source</label>
              <select className="cl-inp cl-sel" value={form.source} onChange={e=>set('source',e.target.value)}>{SOURCES.map(s=><option key={s}>{s}</option>)}</select>
            </div>
            <div className="cl-form-grp"><label className="cl-lbl">Service</label><input className="cl-inp" placeholder="e.g. Web Development" value={form.service} onChange={e=>set('service',e.target.value)}/></div>
          </div>
          <div className="cl-form-row">
            <div className="cl-form-grp"><label className="cl-lbl">Value (₹)</label><input className="cl-inp" type="number" placeholder="e.g. 50000" value={form.value} onChange={e=>set('value',e.target.value)}/></div>
            <div className="cl-form-grp"><label className="cl-lbl">Payment Status</label>
              <select className="cl-inp cl-sel" value={form.payStatus} onChange={e=>set('payStatus',e.target.value)}>{PAY_OPTIONS.map(s=><option key={s} value={s}>{s||'—'}</option>)}</select>
            </div>
          </div>
          <div className="cl-form-row">
            <div className="cl-form-grp"><label className="cl-lbl">Client Status</label>
              <select className="cl-inp cl-sel" value={form.clientStatus} onChange={e=>set('clientStatus',e.target.value)}>{STATUS_OPTIONS.map(s=><option key={s}>{s}</option>)}</select>
            </div>
          </div>
          <div className="cl-form-grp"><label className="cl-lbl">Notes</label><textarea className="cl-inp cl-ta" rows="2" value={form.notes} onChange={e=>set('notes',e.target.value)}/></div>
        </div>
        <div className="cl-modal-ft">
          <button className="cl-btn-sec" onClick={onClose}>Cancel</button>
          <button className="cl-btn-pri" onClick={submit}>{client?'Save Changes':'Add Client'}</button>
        </div>
      </div>
    </div>
  );
}

function ClientPanel({ client, theme, onClose, onDelete, onEdit }) {
  const statusColor = {Active:'#22C55E',Completed:'#3B82F6','On Hold':'#F5A623',Churned:'#EF4444'};
  return (
    <div className="cl-panel-wrap">
      <div className="cl-panel-overlay" onClick={onClose}/>
      <div className="cl-panel" data-theme={theme}>
        <div className="cl-panel-hd">
          <div className="cl-panel-av">{initials(client.name)}</div>
          <div className="cl-panel-info">
            <div className="cl-panel-name">{client.name}</div>
            <div className="cl-panel-co">{client.company||client.businessType||'—'}</div>
          </div>
          <button className="cl-icon-btn" onClick={onClose}><CloseIcon/></button>
        </div>

        <div className="cl-panel-acts">
          {client.phone && <a className="cl-act-btn cl-act-wa" href={`https://wa.me/${client.phone.replace(/\D/g,'')}`} target="_blank" rel="noreferrer">WhatsApp</a>}
          {client.phone && <a className="cl-act-btn" href={`tel:${client.phone}`}>Call</a>}
          {client.email && <a className="cl-act-btn" href={`mailto:${client.email}`}>Email</a>}
          <button className="cl-act-btn cl-act-edit" onClick={()=>onEdit(client)}><EditIcon/> Edit</button>
        </div>

        <div className="cl-panel-body">
          <div className="cl-section-lbl">Status</div>
          <div style={{display:'flex',gap:6,marginBottom:12,flexWrap:'wrap'}}>
            <span style={{borderRadius:20,fontSize:11,fontWeight:600,padding:'3px 10px',background:statusColor[client.clientStatus]+'22',color:statusColor[client.clientStatus]}}>{client.clientStatus||'Active'}</span>
            {client.payStatus && <span style={{borderRadius:20,fontSize:11,fontWeight:600,padding:'3px 10px',background:'#22c55e14',color:'#22c55e'}}>{client.payStatus}</span>}
          </div>

          <div className="cl-section-lbl">Contact</div>
          <div className="cl-kv-grid">
            <span className="cl-k">Phone</span><span className="cl-v">{client.phone||'—'}</span>
            <span className="cl-k">Email</span><span className="cl-v">{client.email||'—'}</span>
            <span className="cl-k">Location</span><span className="cl-v">{client.location||'—'}</span>
          </div>

          <div className="cl-section-lbl" style={{marginTop:14}}>Deal Info</div>
          <div className="cl-kv-grid">
            <span className="cl-k">Service</span><span className="cl-v">{client.service||'—'}</span>
            <span className="cl-k">Value</span><span className="cl-v cl-v-gold">{fmtINR(client.value)}</span>
            <span className="cl-k">Source</span><span className="cl-v">{client.source||'—'}</span>
            <span className="cl-k">Business</span><span className="cl-v">{client.businessType||'—'}</span>
            <span className="cl-k">Added</span><span className="cl-v">{fmtDate(client.convertedAt)}</span>
          </div>

          {client.notes && <>
            <div className="cl-section-lbl" style={{marginTop:14}}>Notes</div>
            <div className="cl-notes">{client.notes}</div>
          </>}
        </div>

        <div className="cl-panel-ft">
          <button className="cl-btn-danger" onClick={()=>{onDelete(client.id);onClose();}}>Remove</button>
          <button className="cl-btn-pri" style={{flex:1}} onClick={()=>onEdit(client)}>Edit</button>
        </div>
      </div>
    </div>
  );
}

export default function Clients() {
  const { theme } = useTheme();
  const [clients, setClients] = useState(() => {
    try { const s = localStorage.getItem(STORAGE_KEY); return s?JSON.parse(s):[]; } catch { return []; }
  });
  React.useEffect(() => { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(clients)); } catch {} }, [clients]);

  const [search, setSearch] = useState('');
  const [panel, setPanel] = useState(null);
  const [addModal, setAddModal] = useState(false);
  const [editClient, setEditClient] = useState(null);

  const filtered = clients.filter(c => {
    const q = search.toLowerCase();
    return !q||c.name?.toLowerCase().includes(q)||c.company?.toLowerCase().includes(q)||c.phone?.includes(q);
  });

  const saveClient = c => setClients(prev => {
    const exists = prev.find(x=>x.id===c.id);
    return exists ? prev.map(x=>x.id===c.id?c:x) : [...prev,c];
  });
  const deleteClient = id => setClients(prev=>prev.filter(c=>c.id!==id));
  const totalValue = clients.reduce((s,c)=>s+(c.value||0),0);

  const TopActions = (
    <div className="cl-top-actions">
      <div className="cl-search-wrap"><SearchIcon/><input className="cl-search" placeholder="Search clients..." value={search} onChange={e=>setSearch(e.target.value)}/></div>
      <button className="cl-add-btn" onClick={()=>setAddModal(true)}><PlusIcon/> Add Client</button>
    </div>
  );

  return (
    <div className="cl-wrap" data-theme={theme}>
      <Sidebar/>
      <div className="cl-main">
        <Topbar title="Clients" subtitle={`${clients.length} clients · ${fmtINR(totalValue)} total value`} actions={TopActions}/>
        <div className="cl-stats">
          {[
            {lbl:'Total Clients',val:clients.length,color:'#F5A623'},
            {lbl:'Total Value',val:fmtINR(totalValue),color:'#22C55E'},
            {lbl:'Active',val:clients.filter(c=>c.clientStatus==='Active'||!c.clientStatus).length,color:'#3B82F6'},
            {lbl:'Fully Paid',val:clients.filter(c=>c.payStatus==='Paid').length,color:'#8B5CF6'},
          ].map(s=>(
            <div key={s.lbl} className="cl-stat">
              <div className="cl-stat-lbl">{s.lbl}</div>
              <div className="cl-stat-val" style={{color:s.color}}>{s.val}</div>
            </div>
          ))}
        </div>
        <div className="cl-content">
          {clients.length===0 ? (
            <div className="cl-empty">
              <div className="cl-empty-icon"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg></div>
              <div className="cl-empty-title">No clients yet</div>
              <div className="cl-empty-sub">Add clients directly or convert leads from the Leads page.</div>
              <button className="cl-btn-pri" onClick={()=>setAddModal(true)}>Add your first client</button>
            </div>
          ) : (
            <div className="cl-grid">
              {filtered.map(c=>(
                <div key={c.id} className="cl-card" onClick={()=>setPanel(c)}>
                  <div className="cl-card-top">
                    <div className="cl-card-av">{initials(c.name)}</div>
                    <div>
                      <div className="cl-card-name">{c.name}</div>
                      <div className="cl-card-co">{c.company||c.businessType||'—'}</div>
                    </div>
                  </div>
                  <div className="cl-card-meta">
                    <span className="cl-card-src">{c.source||'—'}</span>
                    <span className="cl-card-val">{fmtINR(c.value)}</span>
                  </div>
                  <div className="cl-card-service">{c.service||'—'}</div>
                  {c.payStatus && <div className="cl-card-pay">{c.payStatus}</div>}
                  <div className="cl-card-date">Added {fmtDate(c.convertedAt)}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      {panel && <ClientPanel client={panel} theme={theme} onClose={()=>setPanel(null)} onDelete={id=>{deleteClient(id);setPanel(null);}} onEdit={c=>{setPanel(null);setEditClient(c);}}/>}
      {addModal && <ClientModal theme={theme} onClose={()=>setAddModal(false)} onSave={saveClient}/>}
      {editClient && <ClientModal client={editClient} theme={theme} onClose={()=>setEditClient(null)} onSave={c=>{saveClient(c);setEditClient(null);}}/>}
    </div>
  );
}
